import { orderBy } from 'lodash-es';
import { Invoice, InvoiceStatus } from '@/api/apis/case';
import { SortDirection } from './types';
import { invoiceStatusOrder } from './config';

export const sortInvoicesByStatus = (invoices: Invoice[], direction: 'asc' | 'desc' = 'asc') => {
  return orderBy(invoices, [(inv) => invoiceStatusOrder[inv.status]], [direction]);
};

export const toggleSortDirection = (dir: SortDirection) => (dir === 'asc' ? 'desc' : 'asc');

export const getBgColorByInvoiceStatus = (status: InvoiceStatus) => {
  switch (status) {
    case InvoiceStatus.Open:
      return 'bg-warning-30';
    case InvoiceStatus.FullyCredited:
    case InvoiceStatus.PartiallyCredited:
      return 'bg-base-20';
    case InvoiceStatus.PartiallyPaid:
    case InvoiceStatus.Paid:
      return 'bg-success-40';
    default:
      return 'bg-base-20';
  }
};
